import type { NAICSCodeGroupMap } from "@inrev/common";

const CONSTRUCTION_SECTOR_CODE = "23";

export const sortNaicsCodeGroupMap = (groupMap: NAICSCodeGroupMap): NAICSCodeGroupMap =>
	new Map(
		[...groupMap.entries()].sort(([aBaseCode, aGroup], [bBaseCode, bGroup]) => {
			const aIsConstruction = aBaseCode.startsWith(CONSTRUCTION_SECTOR_CODE);
			if (aIsConstruction !== bBaseCode.startsWith(CONSTRUCTION_SECTOR_CODE)) {
				return aIsConstruction ? -1 : 1;
			}
			return aGroup.label.localeCompare(bGroup.label);
		}),
	);
